export default __webpack_public_path__ + "static/media/3.95226d70.jpg";